import React from "react";
import { useCompare } from "properties/propertyCard/components/favorite/compare-provider";
import { useTranslation } from "react-i18next";
import { Button } from "_common/ui/mui/buttons/Button";
import { UnitCompareCard } from "properties/compare/banner/compare-banner-unit-card";
import { PropertyCompareCard } from "properties/compare/banner/compare-banner-property-card";
import { COMMON_RESOURCE } from "_common/resources/BaseResourceStore";
import { useLocation } from "react-router-dom";
import { ADMIN_URLS } from "admin/_configs/ADMIN_URLS";

export const MAX_COMPARE_ITEMS = 5;

export default function CompareBanner() {
    const { itemsSelected, openModal } = useCompare();
    const { t } = useTranslation();
    const location = useLocation();
    if (location.pathname.startsWith(ADMIN_URLS.home())) return null;
    if (!itemsSelected.length) return null;
    return (
        <div className="fixed bottom-0 left-0 w-full py-5 bg-white flex flex-col justify-center items-center lg:flex-row lg:items-center lg:justify-end !z-[50 border-t border-gray-300">
            <div className={"mb-5 text-sm lg:mr-5 lg:mb-0 lg:text-md"}>
                {itemsSelected.length >= 5
                    ? t("propertiesPage.compareBannerMessageMax")
                    : t("propertiesPage.compareBannerMessage", {
                          count: MAX_COMPARE_ITEMS - itemsSelected.length,
                      })}
            </div>
            <div className={"flex flex-col lg:flex-row items-center justify-center"}>
                <div className="flex flex-wrap mb-5 lg:mb-0 space-x-5">
                    {itemsSelected.map((item, index) => {
                        if (item.resource === COMMON_RESOURCE.PROPERTIES) {
                            return <PropertyCompareCard key={index} itemId={item.itemId} />;
                        }
                        if (item.resource === COMMON_RESOURCE.UNIT) {
                            return <UnitCompareCard key={index} itemId={item.itemId} />;
                        }
                        return null;
                    })}
                </div>
                <div className={"mx-5"}>
                    <Button
                        variant={itemsSelected.length < 2 ? "outlined" : "contained"}
                        style={{ borderRadius: 30 }}
                        color={"primary"}
                        disabled={itemsSelected.length < 2}
                        onClick={openModal}
                    >
                        {t("propertiesPage.compare")}
                    </Button>
                </div>
            </div>
        </div>
    );
}
